// The unsaved-changes modal's copy (Figma 15949-170754 for a draft,
// 15949-174922 for scratch work). Kept apart from LeaveGuard.tsx so it can
// be unit-tested without the React tree.

export type UnsavedWorkKind = "draft" | "scratch" | "deployed";

/** The keep-the-work button: what saving does to this kind of work — a
 *  draft saves over itself, scratch becomes a draft — before leaving.
 *  Every held move leaves the work behind (navigation, Clear, opening
 *  another pipeline), so the wording is the same for all of them. */
export function leaveModalKeepLabel(kind: "draft" | "scratch"): string {
  return kind === "draft" ? "Save and leave" : "Save as draft and leave";
}

/** The warning line. Saveable work gets the design's one sentence; a
 *  deployed pipeline's local edits have nothing to save them to, so the
 *  line says why and points at duplicating instead. */
export function leaveModalMessage(unsaved: {
  kind: UnsavedWorkKind;
  name: string | null;
}): string {
  if (unsaved.kind === "deployed") {
    return `Your edits to "${unsaved.name}" are local and not part of the deployed pipeline. Leave now and they are lost — or cancel and duplicate it as a draft first.`;
  }
  return "You have not saved the changes you have been working on. If you continue they will be lost.";
}
